var _path, _path2, _path3, _rect, _g, _path4, _path5, _rect2, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRaspberry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 275C65.4 275 5 214.6 5 140C5 65.4 65.4 5 140 5C214.6 5 275 65.4 275 140C275 214.6 214.6 275 140 275Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.918 174.737L107.946 175.398L111.083 213.269L119.056 212.608L115.918 174.737Z",
    fill: "#1F201D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 175H152.5V213H160.5V175Z",
    fill: "#1F201D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 226,
    width: 90,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 226,
    width: 90,
    height: 15,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137 238C160.472 238 179.5 235.761 179.5 233C179.5 230.239 160.472 228 137 228C113.528 228 94.5 230.239 94.5 233C94.5 235.761 113.528 238 137 238Z",
    fill: "#BFC3CE"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107 231C116.665 231 124.5 226.075 124.5 220C124.5 213.925 116.665 209 107 209C97.335 209 89.5 213.925 89.5 220C89.5 226.075 97.335 231 107 231Z",
    fill: "#1F201D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165 231C174.665 231 182.5 226.075 182.5 220C182.5 213.925 174.665 209 165 209C155.335 209 147.5 213.925 147.5 220C147.5 226.075 155.335 231 165 231Z",
    fill: "#1F201D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 213,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 213,
    width: 10,
    height: 10,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176 220C177.381 220 178.5 218.881 178.5 217.5C178.5 216.119 177.381 215 176 215C174.619 215 173.5 216.119 173.5 217.5C173.5 218.881 174.619 220 176 220Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137 206C149.426 206 159.5 195.926 159.5 183.5C159.5 171.074 149.426 161 137 161C124.574 161 114.5 171.074 114.5 183.5C114.5 195.926 124.574 206 137 206Z",
    fill: "url(#paint0_linear_1_424)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150 96C162.426 96 172.5 85.9264 172.5 73.5C172.5 61.0736 162.426 51 150 51C137.574 51 127.5 61.0736 127.5 73.5C127.5 85.9264 137.574 96 150 96Z",
    fill: "url(#paint1_linear_1_424)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168 47C168 48.3 167.5 49.5 166.7 50.4C165.7 50.9 164.7 51.4 163.7 52C155.5 56.9 150 65.8 150 76C150 76.1 150 76.2 150 76.3C149.1 76.1 148.1 76 147 76C145.6 76 144.2 76.2 143 76.5C142.3 74.1 142 71.6 142 69C142 56.8 149.7 46.5 160.6 42.6C161.2 42.4 161.9 42.2 162.5 42C162.7 42 162.8 42 163 42C165.7 42 168 44.2 168 47Z",
    fill: "#6E3126"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198 151C210.426 151 220.5 140.926 220.5 128.5C220.5 116.074 210.426 106 198 106C185.574 106 175.5 116.074 175.5 128.5C175.5 140.926 185.574 151 198 151Z",
    fill: "url(#paint2_linear_1_424)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.5 174C172.562 174 194.5 151.39 194.5 123.5C194.5 95.6096 172.562 73 145.5 73C118.438 73 96.5 95.6096 96.5 123.5C96.5 151.39 118.438 174 145.5 174Z",
    fill: "url(#paint3_linear_1_424)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132 114C144.426 114 154.5 103.926 154.5 91.5C154.5 79.0736 144.426 69 132 69C119.574 69 109.5 79.0736 109.5 91.5C109.5 103.926 119.574 114 132 114Z",
    fill: "url(#paint4_linear_1_424)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M180 101C192.426 101 202.5 90.9264 202.5 78.5C202.5 66.0736 192.426 56 180 56C167.574 56 157.5 66.0736 157.5 78.5C157.5 90.9264 167.574 101 180 101Z",
    fill: "url(#paint5_linear_1_424)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109 96C121.426 96 131.5 85.9264 131.5 73.5C131.5 61.0736 121.426 51 109 51C96.5736 51 86.5 61.0736 86.5 73.5C86.5 85.9264 96.5736 96 109 96Z",
    fill: "url(#paint6_linear_1_424)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166 111C178.426 111 188.5 100.926 188.5 88.5C188.5 76.0736 178.426 66 166 66C153.574 66 143.5 76.0736 143.5 88.5C143.5 100.926 153.574 111 166 111Z",
    fill: "url(#paint7_linear_1_424)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M138 106C150.426 106 160.5 95.9264 160.5 83.5C160.5 71.0736 150.426 61 138 61C125.574 61 115.5 71.0736 115.5 83.5C115.5 95.9264 125.574 106 138 106Z",
    fill: "url(#paint8_linear_1_424)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93 173C105.426 173 115.5 162.926 115.5 150.5C115.5 138.074 105.426 128 93 128C80.5736 128 70.5 138.074 70.5 150.5C70.5 162.926 80.5736 173 93 173Z",
    fill: "url(#paint9_linear_1_424)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M182 181C194.426 181 204.5 170.926 204.5 158.5C204.5 146.074 194.426 136 182 136C169.574 136 159.5 146.074 159.5 158.5C159.5 170.926 169.574 181 182 181Z",
    fill: "url(#paint10_linear_1_424)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160 197C172.426 197 182.5 186.926 182.5 174.5C182.5 162.074 172.426 152 160 152C147.574 152 137.5 162.074 137.5 174.5C137.5 186.926 147.574 197 160 197Z",
    fill: "url(#paint11_linear_1_424)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M202 111C214.426 111 224.5 100.926 224.5 88.5C224.5 76.0736 214.426 66 202 66C189.574 66 179.5 76.0736 179.5 88.5C179.5 100.926 189.574 111 202 111Z",
    fill: "url(#paint12_linear_1_424)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78 133C90.4264 133 100.5 122.926 100.5 110.5C100.5 98.0736 90.4264 88 78 88C65.5736 88 55.5 98.0736 55.5 110.5C55.5 122.926 65.5736 133 78 133Z",
    fill: "url(#paint13_linear_1_424)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109 197C121.426 197 131.5 186.926 131.5 174.5C131.5 162.074 121.426 152 109 152C96.5736 152 86.5 162.074 86.5 174.5C86.5 186.926 96.5736 197 109 197Z",
    fill: "url(#paint14_linear_1_424)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M137 173C149.426 173 159.5 162.926 159.5 150.5C159.5 138.074 149.426 128 137 128C124.574 128 114.5 138.074 114.5 150.5C114.5 162.926 124.574 173 137 173Z",
    fill: "url(#paint15_linear_1_424)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114 144C126.426 144 136.5 133.926 136.5 121.5C136.5 109.074 126.426 99 114 99C101.574 99 91.5 109.074 91.5 121.5C91.5 133.926 101.574 144 114 144Z",
    fill: "url(#paint16_linear_1_424)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M160 146C172.426 146 182.5 135.926 182.5 123.5C182.5 111.074 172.426 101 160 101C147.574 101 137.5 111.074 137.5 123.5C137.5 135.926 147.574 146 160 146Z",
    fill: "url(#paint17_linear_1_424)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M97 106C109.426 106 119.5 95.9264 119.5 83.5C119.5 71.0736 109.426 61 97 61C84.5736 61 74.5 71.0736 74.5 83.5C74.5 95.9264 84.5736 106 97 106Z",
    fill: "url(#paint18_linear_1_424)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M116 125C119.59 125 122.5 122.09 122.5 118.5C122.5 114.91 119.59 112 116 112C112.41 112 109.5 114.91 109.5 118.5C109.5 122.09 112.41 125 116 125Z",
    fill: "#4C1A1D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M158 125C161.59 125 164.5 122.09 164.5 118.5C164.5 114.91 161.59 112 158 112C154.41 112 151.5 114.91 151.5 118.5C151.5 122.09 154.41 125 158 125Z",
    fill: "#4C1A1D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M149.4 133C150.9 138.9 147.4 144.9 141.6 146.4C135.7 147.9 129.7 144.4 128.2 138.6",
    fill: "#FFF3F3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7 134.5C75.7 134.5 62.7 149.5 64.7 152.5C66.7 155.5 73.7 157.5 77.7 159.5C81.7 161.5 91.2 170.5 86.9 172C82.7 173.5 79.1 174.5 77.4 172",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M199.1 134.5C199.1 134.5 208.1 169.5 193.1 187.5",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_424",
    transform: "scale(0.0111111 0.0666667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_424",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_424",
    x1: 117.493,
    y1: 178.375,
    x2: 161.021,
    y2: 189.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_424",
    x1: 130.493,
    y1: 68.3746,
    x2: 174.021,
    y2: 79.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_424",
    x1: 178.493,
    y1: 123.375,
    x2: 222.021,
    y2: 134.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_424",
    x1: 102.933,
    y1: 112.303,
    x2: 197.918,
    y2: 137.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_424",
    x1: 112.493,
    y1: 86.3746,
    x2: 156.021,
    y2: 97.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_424",
    x1: 160.493,
    y1: 73.3746,
    x2: 204.021,
    y2: 84.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_424",
    x1: 89.4932,
    y1: 68.3746,
    x2: 133.021,
    y2: 79.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_424",
    x1: 146.493,
    y1: 83.3746,
    x2: 190.021,
    y2: 94.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_424",
    x1: 118.493,
    y1: 78.3746,
    x2: 162.021,
    y2: 89.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_424",
    x1: 73.4932,
    y1: 145.375,
    x2: 117.021,
    y2: 156.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_424",
    x1: 162.493,
    y1: 153.375,
    x2: 206.021,
    y2: 164.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_424",
    x1: 140.493,
    y1: 169.375,
    x2: 184.021,
    y2: 180.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_424",
    x1: 182.493,
    y1: 83.3746,
    x2: 226.021,
    y2: 94.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_424",
    x1: 58.4932,
    y1: 105.375,
    x2: 102.021,
    y2: 116.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_424",
    x1: 89.4932,
    y1: 169.375,
    x2: 133.021,
    y2: 180.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_424",
    x1: 117.493,
    y1: 145.375,
    x2: 161.021,
    y2: 156.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_424",
    x1: 94.4932,
    y1: 116.375,
    x2: 138.021,
    y2: 127.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_424",
    x1: 140.493,
    y1: 118.375,
    x2: 184.021,
    y2: 129.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_424",
    x1: 77.4932,
    y1: 78.3746,
    x2: 121.021,
    y2: 89.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8754e-8,
    stopColor: "#D5001E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD007F"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_424",
    width: 90,
    height: 15,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAGpAAACBwAAAtX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA8AWgMBIgACEQEDEQH/xACLAAADAQEAAAAAAAAAAAAAAAAEBQYAAwEBAAAAAAAAAAAAAAAAAAAAABAAAAYCAwEBAAAAAAAAAAAAAAIDBAUGARcgFgcRExEAAQIDBAcECwAAAAAAAAAAAQIDABEEMdGSEyFBEpPTBTUQgaGxkcFiorLCI2ODFCUSAQAAAAAAAAAAAAAAAAAAACD/2gAMAwEAAhEDEQAAAI6qj6IoO6ggPwBJ2wGDF+XipKxXH//aAAgBAgABBQDl/9oACAEDAAEFAOX/2gAIAQEAAQUAjIdzJHZeaqqptvNI0hdcQY1xBjXEGNcQY1xBhXzaIMRfzHBU5WrvYzAZHkCKNZe8optrLeEi9ruQ7ZcglbrJ+ebZcfva7kFrRdTkUm74Yr9acUwP/9oACAECAgY/AF//2gAIAQMCBj8AX//aAAgBAQEGPwAJZKUpnIqN0bVRVSnZsADR3zg57y3SbDOUsMotXiN8WrxG+LV4jfFq8Rvi1eI3wQ2taFGxUyZemFFmqUVgaNoCXkIKlrS4kWkaOzaocwr+2CrwAMBLdNUuJ1KNO4fhAgh3lVQ8dRyHU/KY6JUbl3hx0So3LvDj6vIqvM9lhwjxSI0ckqB+F3hx0So3LvDgpRyeobUbFZLpl7gghVHUAHX+u6PVH9APga8xBQPIdn//2Q=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_424",
    width: 10,
    height: 10,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAF1AAABhAAAAbD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAoACgMBIgACEQEDEQH/xABpAAEBAQAAAAAAAAAAAAAAAAAABQYBAQAAAAAAAAAAAAAAAAAAAAAQAAIDAAAAAAAAAAAAAAAAAAAFEAMEEQABBAMAAAAAAAAAAAAAAAARAQIDBCBBUhIBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAAAAzsEP/9oACAECAAEFAD//2gAIAQMAAQUAP//aAAgBAQABBQBXhQXJ5//aAAgBAgIGPwB//9oACAEDAgY/AH//2gAIAQEBBj8AsWLsystxkNIHITeH/9k="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaspberry);
export default __webpack_public_path__ + "static/media/raspberry.81fb12732f5d44b37869412fadebb3a9.svg";
export { ForwardRef as ReactComponent };